const NOISE_TEXTURE = `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='2.5' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`;

export const OrbitalBackground = () => (
  <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
    {/* Removed bg-neutral-950 from here ^^^^^^ */}
    
    {/* Main Spotlight */}
    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[600px] bg-white/5 rounded-[100%] blur-3xl" />
    <div className="absolute top-[-200px] left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-indigo-500/10 rounded-[100%] blur-[100px]" />
    
    {/* Fine Grain Texture Overlay */}
    <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: NOISE_TEXTURE }}></div>
  </div>
);
  
  // --- Variant 4: Horizon (Orbital Bottom-Up) ---
export const HorizonBackground = () => (
<div className="absolute inset-0 overflow-hidden pointer-events-none bg-neutral-950">
    {/* Bottom Glow Base */}
    <div className="absolute bottom-[-100px] left-1/2 -translate-x-1/2 w-[120%] h-[400px] bg-white/5 rounded-[100%] blur-3xl" />
    {/* Deep Color Glow */}
    <div className="absolute bottom-[-150px] left-1/2 -translate-x-1/2 w-[100%] h-[500px] bg-emerald-500/15 rounded-[100%] blur-[80px]" />
    
    {/* Fine Grain Texture Overlay */}
    <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='2.5' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")` }}></div>
</div>
);